import React, { useEffect } from 'react';
import { SetPageTitle } from '../../utilities/TitleHelper';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import JsonApiLogGrid from '../../components/jsonApiLog/JsonApiLogGrid';


const JsonApiLog = props => {

  const { t } = useTranslation();

  useEffect(() => {
    SetPageTitle('JSON API log');
  }, [])

  return (
    <>

      <div className="content p-4">

        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><Link to="/">{t('dashboard:hdgHeading')}</Link></li>            
            <li className="breadcrumb-item active" aria-current="page">{t('jsonApiLog:hdgHeading')}</li>
          </ol>
        </nav>        
        
        <JsonApiLogGrid />
      </div>
    </> 
  );
}


export default JsonApiLog;